import { isPlainObject } from './common';


export function getCsrfToken() {
    let csrfMeta = document.querySelector('meta[name="csrf-token"]');
    return csrfMeta ? csrfMeta.getAttribute('content') : null;
}

export function generateFormData(sourceData = null, formData = null, baseKey = null, dataConverter = undefined) {
    if(!formData) {
        formData = new FormData();
    }
    if(dataConverter === undefined) {
        dataConverter = formDataConverter;
    }

    Object.keys(sourceData).forEach(key => {
        let data = sourceData[key];

        if(data !== undefined) {
            if(baseKey) {
                key = baseKey + '[' + key + ']';
            }

            if(isPlainObject(data)) {
                generateFormData(data, formData, key);
            } else if(Array.isArray(data)) {
                data.forEach((d, i) => {
                    if(isPlainObject(d)) {
                        generateFormData(d, formData, key + '[' + i + ']')
                    } else {
                        if(dataConverter) {
                            d = dataConverter(d);
                        }
                        formData.append(key + '[' + i + ']', d);
                    }
                });
            } else {
                if(dataConverter) {
                    data = dataConverter(data);
                }
                formData.append(key, data);
            }
        }
    });

    return formData;
}


export function formDataConverter(data) {
    if(typeof data == 'object' && data instanceof Date) {
        return Math.round(data.getTime() / 1000);
    }

    if(data === null) {
        return "";
    }

    return data;
}

export { validate } from './forms/validation';